import type { Ceviri } from "../tip";
import type { tr } from "../tr";
import { ortak } from "./ortak";
import { bicim } from "./bicim";
import { ui } from "./ui";
import { kabuk } from "./kabuk";
import { rapor } from "./rapor";
import { yedek } from "./yedek";
import { kilit } from "./kilit";
import { donemsel } from "./donemsel";
import { grafik } from "./grafik";
import { iceAktar } from "./iceAktar";
import { ayarlar } from "./ayarlar";
import { sanal } from "./sanal";
import { hesaplar } from "./hesaplar";
import { anaSayfa } from "./anaSayfa";
import { izleme } from "./izleme";
import { hareketler } from "./hareketler";
import { motor } from "./motor";
import { formul } from "./formul";

/** English dictionary: every namespace. */
export const en: Ceviri<typeof tr> = {
  ortak,
  bicim,
  ui,
  kabuk,
  rapor,
  yedek,
  kilit,
  donemsel,
  grafik,
  iceAktar,
  ayarlar,
  sanal,
  hesaplar,
  anaSayfa,
  izleme,
  hareketler,
  motor,
  formul,
};
